module.exports = __webpack_public_path__ + "media/images/serie_b-501a44fbe7b02a9a94278d37d661c259.png";